/**
 * TASK-EMM-1020: helper Notices.
 * - Snooze popup Critical di localStorage (Keputusan 6)
 * - Format tanggal tanpa hitung timezone (Keputusan 4)
 * - Audience bell (Keputusan 3)
 * - Deteksi white-label, aturannya sama dengan NoticeContentService.php (Keputusan 2)
 */

const SNOOZE_PREFIX = 'notice_snooze_';
const SNOOZE_MS = 24 * 60 * 60 * 1000;

export const NOTICE_TYPES = [
  { value: 'info', label: 'Info', effect: 'Shown in the bell only' },
  { value: 'warning', label: 'Warning', effect: 'Shown in the bell only (yellow)' },
  { value: 'critical', label: 'Critical', effect: 'Shown in the bell + popup in the middle of the screen' },
];

export const NOTICE_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'expired', label: 'Expired' },
  { value: 'inactive', label: 'Inactive' },
];

export function noticeTypeLabel(type) {
  const found = NOTICE_TYPES.find(item => item.value === type);
  return found ? found.label : type;
}

export function noticeStatusLabel(status) {
  const found = NOTICE_STATUSES.find(item => item.value === status);
  return found ? found.label : status;
}

/**
 * 'YYYY-MM-DD' -> 'MM-DD-YYYY' dengan memecah string, tanpa objek Date,
 * supaya timezone laptop tidak menggeser tanggal.
 */
export function formatNoticeDate(value) {
  if (!value || typeof value !== 'string') return '';
  const parts = value.split('-');
  if (parts.length !== 3) return value;
  return `${parts[1]}-${parts[2]}-${parts[0]}`;
}

/**
 * Bell hanya untuk agency dan client. Saat view-as, $global mengikuti user yang sedang dilihat.
 */
export function isNoticeAudience(global) {
  if (!global) return false;
  if (global.menuUserType === 'client') return true;
  return (global.menuUserType === 'userdownline' || global.menuUserType === 'user') && global.systemUser !== true;
}

/* ====== Snooze (localStorage) ======= */
function snoozeKey(userId, noticeId) {
  return `${SNOOZE_PREFIX}${userId}_${noticeId}`;
}

// localStorage bisa tidak tersedia (mode privat atau diblokir). Kalau gagal, popup tetap muncul setiap halaman dimuat.
export function snoozeNotice(userId, noticeId) {
  try {
    localStorage.setItem(snoozeKey(userId, noticeId), String(Date.now() + SNOOZE_MS));
  } catch (e) {
    // abaikan
  }
}

export function isNoticeSnoozed(userId, noticeId) {
  try {
    const until = parseInt(localStorage.getItem(snoozeKey(userId, noticeId)), 10);
    return !isNaN(until) && until > Date.now();
  } catch (e) {
    return false;
  }
}

function removeSnoozeKeys(shouldRemove) {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.indexOf(SNOOZE_PREFIX) === 0 && shouldRemove(key)) {
        keys.push(key);
      }
    }
    keys.forEach(key => localStorage.removeItem(key));
  } catch (e) {
    // abaikan
  }
}

/**
 * Hapus snooze milik user yang tadi dilihat. Dipanggil di semua revertViewMode.
 */
export function clearNoticeSnooze(userId) {
  if (!userId) return;
  const prefix = `${SNOOZE_PREFIX}${userId}_`;
  removeSnoozeKeys(key => key.indexOf(prefix) === 0);
}

/**
 * Rapikan key yang sudah lewat 24 jam. Dipanggil saat bell pertama kali dimuat.
 */
export function cleanupExpiredNoticeSnoozes() {
  const now = Date.now();
  removeSnoozeKeys(key => {
    const until = parseInt(localStorage.getItem(key), 10);
    return isNaN(until) || until <= now;
  });
}
/* ====== Snooze (localStorage) ======= */

/* ====== White-label ======= */
function decodeEntities(text) {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}

/**
 * Decode entity, rapikan spasi (termasuk &nbsp;), lalu lowercase.
 */
export function normalizeNoticeText(text) {
  return decodeEntities(String(text || '')).replace(/[\s ]+/g, ' ').trim().toLowerCase();
}

/**
 * Kata root yang muncul di title, teks content, atau href link.
 * terms sudah dinormalisasi oleh backend (GET /notices/white-label-terms).
 */
export function detectWhiteLabelTerms(terms, title, html) {
  const source = String(html || '');
  const hrefs = [];
  const hrefRegex = /href\s*=\s*"([^"]*)"/gi;
  let match = hrefRegex.exec(source);
  while (match !== null) {
    hrefs.push(match[1]);
    match = hrefRegex.exec(source);
  }

  // tag diganti spasi, supaya kata di dua tag berbeda tidak menempel
  const text = source.replace(/<[^>]*>/g, ' ');
  const haystack = normalizeNoticeText(`${title || ''} ${text} ${hrefs.join(' ')}`);

  return (terms || []).filter(term => term && haystack.indexOf(term) !== -1);
}
/* ====== White-label ======= */
